const getModuleState = (state) => state.users;

export const getUserLoggedData = (state) => getModuleState(state).login;
// export const getUserData = (state) => getModuleState(state).userData;


